export default __webpack_public_path__ + "static/media/St._Doms_64.f1c2f033.jpg";